import React from 'react'
import { Typography, Button } from '@material-ui/core'
import { ButtonWithLoading } from 'app/components/FormsyHelperComponent'
import { makeStyles } from '@material-ui/styles'
import PropTypes from 'prop-types'
import { darken } from '@material-ui/core/styles/colorManipulator'
import clsx from 'clsx'
import * as R from 'ramda'

const useStyle = makeStyles((theme) => ({
  root: {
    backgroundColor: `${theme.palette.negative.main}`,
    color: 'white',
    '&:hover': {
      backgroundColor: `${darken(theme.palette.negative.main, 0.2)}`,
    },
  },
}))

export const PlanBillingNegativeActionBar = ({
  buttonProps,
  buttonText,
  onClick,
  ...props
}) => {
  const classes = useStyle()
  return (
    <PlanBillingActionBar {...props}>
      <ButtonWithLoading
        onClick={onClick}
        {...buttonProps}
        className={clsx(classes.root, R.prop('className', buttonProps))}
      >
        {buttonText}
      </ButtonWithLoading>
    </PlanBillingActionBar>
  )
}

PlanBillingNegativeActionBar.propTypes = {
  text: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
  buttonProps: PropTypes.object,
  buttonText: PropTypes.oneOfType([PropTypes.element, PropTypes.string])
    .isRequired,
  onClick: PropTypes.func.isRequired,
}

export const PlanBillingPositiveActionBar = ({
  buttonProps,
  onClick,
  buttonText,
  ...props
}) => {
  return (
    <PlanBillingActionBar {...props}>
      <Button
        onClick={onClick}
        variant="contained"
        color="secondary"
        {...buttonProps}
      >
        {buttonText}
      </Button>
    </PlanBillingActionBar>
  )
}

PlanBillingPositiveActionBar.propTypes = {
  text: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
  buttonProps: PropTypes.object,
  buttonText: PropTypes.oneOfType([PropTypes.element, PropTypes.string])
    .isRequired,
  onClick: PropTypes.func.isRequired,
}

const PlanBillingActionBar = ({
  text,
  textClassName,
  textProps,
  children,
  ...rest
}) => {
  return (
    <div className="flex justify-between items-center" {...rest}>
      <Typography
        variant="subtitle1"
        className={clsx('flex-1 font-bold', textClassName)}
        {...textProps}
      >
        {text}
      </Typography>
      {children}
    </div>
  )
}

export { PlanBillingActionBar }
